/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../actor/defs.defs.js'
import * as EmbedImages from '../embed/images.defs.js'
import * as EmbedVideo from '../embed/video.defs.js'
import * as EmbedExternal from '../embed/external.defs.js'
import * as EmbedRecord from '../embed/record.defs.js'
import * as EmbedRecordWithMedia from '../embed/recordWithMedia.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'
import * as RichtextFacet from '../richtext/facet.defs.js'
import * as GraphDefs from '../graph/defs.defs.js'

const $nsid = 'app.bsky.feed.defs'

export { $nsid }

type PostView = {
  $type?: 'app.bsky.feed.defs#postView'
  uri: l.AtUriString
  cid: l.CidString
  author: ActorDefs.ProfileViewBasic
  record: l.LexMap
  embed?:
    | l.$Typed<EmbedImages.View>
    | l.$Typed<EmbedVideo.View>
    | l.$Typed<EmbedExternal.View>
    | l.$Typed<EmbedRecord.View>
    | l.$Typed<EmbedRecordWithMedia.View>
    | l.Unknown$TypedObject
  bookmarkCount?: number
  replyCount?: number
  repostCount?: number
  likeCount?: number
  quoteCount?: number
  indexedAt: l.DatetimeString
  viewer?: ViewerState
  labels?: LabelDefs.Label[]
  threadgate?: ThreadgateView

  /**
   * Debug information for internal development
   */
  debug?: l.LexMap
}

export type { PostView }

const postView = l.typedObject<PostView>(
  $nsid,
  'postView',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    author: l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    record: l.lexMap(),
    embed: l.optional(
      l.typedUnion(
        [
          l.typedRef<EmbedImages.View>((() => EmbedImages.view) as any),
          l.typedRef<EmbedVideo.View>((() => EmbedVideo.view) as any),
          l.typedRef<EmbedExternal.View>((() => EmbedExternal.view) as any),
          l.typedRef<EmbedRecord.View>((() => EmbedRecord.view) as any),
          l.typedRef<EmbedRecordWithMedia.View>(
            (() => EmbedRecordWithMedia.view) as any,
          ),
        ],
        false,
      ),
    ),
    bookmarkCount: l.optional(l.integer()),
    replyCount: l.optional(l.integer()),
    repostCount: l.optional(l.integer()),
    likeCount: l.optional(l.integer()),
    quoteCount: l.optional(l.integer()),
    indexedAt: l.string({ format: 'datetime' }),
    viewer: l.optional(l.ref<ViewerState>((() => viewerState) as any)),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    threadgate: l.optional(
      l.ref<ThreadgateView>((() => threadgateView) as any),
    ),
    debug: l.optional(l.lexMap()),
  }),
)

export { postView }

/** Metadata about the requesting account's relationship with the subject content. Only has meaningful content for authed requests. */
type ViewerState = {
  $type?: 'app.bsky.feed.defs#viewerState'
  repost?: l.AtUriString
  like?: l.AtUriString
  bookmarked?: boolean
  threadMuted?: boolean
  replyDisabled?: boolean
  embeddingDisabled?: boolean
  pinned?: boolean
}

export type { ViewerState }

/** Metadata about the requesting account's relationship with the subject content. Only has meaningful content for authed requests. */
const viewerState = l.typedObject<ViewerState>(
  $nsid,
  'viewerState',
  l.object({
    repost: l.optional(l.string({ format: 'at-uri' })),
    like: l.optional(l.string({ format: 'at-uri' })),
    bookmarked: l.optional(l.boolean()),
    threadMuted: l.optional(l.boolean()),
    replyDisabled: l.optional(l.boolean()),
    embeddingDisabled: l.optional(l.boolean()),
    pinned: l.optional(l.boolean()),
  }),
)

export { viewerState }

/** Metadata about this post within the context of the thread it is in. */
type ThreadContext = {
  $type?: 'app.bsky.feed.defs#threadContext'
  rootAuthorLike?: l.AtUriString
}

export type { ThreadContext }

/** Metadata about this post within the context of the thread it is in. */
const threadContext = l.typedObject<ThreadContext>(
  $nsid,
  'threadContext',
  l.object({ rootAuthorLike: l.optional(l.string({ format: 'at-uri' })) }),
)

export { threadContext }

type FeedViewPost = {
  $type?: 'app.bsky.feed.defs#feedViewPost'
  post: PostView
  reply?: ReplyRef
  reason?: l.$Typed<ReasonRepost> | l.$Typed<ReasonPin> | l.Unknown$TypedObject

  /**
   * Context provided by feed generator that may be passed back alongside interactions.
   */
  feedContext?: string

  /**
   * Unique identifier per request that may be passed back alongside interactions.
   */
  reqId?: string
}

export type { FeedViewPost }

const feedViewPost = l.typedObject<FeedViewPost>(
  $nsid,
  'feedViewPost',
  l.object({
    post: l.ref<PostView>((() => postView) as any),
    reply: l.optional(l.ref<ReplyRef>((() => replyRef) as any)),
    reason: l.optional(
      l.typedUnion(
        [
          l.typedRef<ReasonRepost>((() => reasonRepost) as any),
          l.typedRef<ReasonPin>((() => reasonPin) as any),
        ],
        false,
      ),
    ),
    feedContext: l.optional(l.string({ maxLength: 2000 })),
    reqId: l.optional(l.string({ maxLength: 100 })),
  }),
)

export { feedViewPost }

type ReplyRef = {
  $type?: 'app.bsky.feed.defs#replyRef'
  root:
    | l.$Typed<PostView>
    | l.$Typed<NotFoundPost>
    | l.$Typed<BlockedPost>
    | l.Unknown$TypedObject
  parent:
    | l.$Typed<PostView>
    | l.$Typed<NotFoundPost>
    | l.$Typed<BlockedPost>
    | l.Unknown$TypedObject

  /**
   * When parent is a reply to another post, this is the author of that post.
   */
  grandparentAuthor?: ActorDefs.ProfileViewBasic
}

export type { ReplyRef }

const replyRef = l.typedObject<ReplyRef>(
  $nsid,
  'replyRef',
  l.object({
    root: l.typedUnion(
      [
        l.typedRef<PostView>((() => postView) as any),
        l.typedRef<NotFoundPost>((() => notFoundPost) as any),
        l.typedRef<BlockedPost>((() => blockedPost) as any),
      ],
      false,
    ),
    parent: l.typedUnion(
      [
        l.typedRef<PostView>((() => postView) as any),
        l.typedRef<NotFoundPost>((() => notFoundPost) as any),
        l.typedRef<BlockedPost>((() => blockedPost) as any),
      ],
      false,
    ),
    grandparentAuthor: l.optional(
      l.ref<ActorDefs.ProfileViewBasic>(
        (() => ActorDefs.profileViewBasic) as any,
      ),
    ),
  }),
)

export { replyRef }

type ReasonRepost = {
  $type?: 'app.bsky.feed.defs#reasonRepost'
  by: ActorDefs.ProfileViewBasic
  uri?: l.AtUriString
  cid?: l.CidString
  indexedAt: l.DatetimeString
}

export type { ReasonRepost }

const reasonRepost = l.typedObject<ReasonRepost>(
  $nsid,
  'reasonRepost',
  l.object({
    by: l.ref<ActorDefs.ProfileViewBasic>(
      (() => ActorDefs.profileViewBasic) as any,
    ),
    uri: l.optional(l.string({ format: 'at-uri' })),
    cid: l.optional(l.string({ format: 'cid' })),
    indexedAt: l.string({ format: 'datetime' }),
  }),
)

export { reasonRepost }

type ReasonPin = { $type?: 'app.bsky.feed.defs#reasonPin' }

export type { ReasonPin }

const reasonPin = l.typedObject<ReasonPin>($nsid, 'reasonPin', l.object({}))

export { reasonPin }

type ThreadViewPost = {
  $type?: 'app.bsky.feed.defs#threadViewPost'
  post: PostView
  parent?:
    | l.$Typed<ThreadViewPost>
    | l.$Typed<NotFoundPost>
    | l.$Typed<BlockedPost>
    | l.Unknown$TypedObject
  replies?: (
    | l.$Typed<ThreadViewPost>
    | l.$Typed<NotFoundPost>
    | l.$Typed<BlockedPost>
    | l.Unknown$TypedObject
  )[]
  threadContext?: ThreadContext
}

export type { ThreadViewPost }

const threadViewPost = l.typedObject<ThreadViewPost>(
  $nsid,
  'threadViewPost',
  l.object({
    post: l.ref<PostView>((() => postView) as any),
    parent: l.optional(
      l.typedUnion(
        [
          l.typedRef<ThreadViewPost>((() => threadViewPost) as any),
          l.typedRef<NotFoundPost>((() => notFoundPost) as any),
          l.typedRef<BlockedPost>((() => blockedPost) as any),
        ],
        false,
      ),
    ),
    replies: l.optional(
      l.array(
        l.typedUnion(
          [
            l.typedRef<ThreadViewPost>((() => threadViewPost) as any),
            l.typedRef<NotFoundPost>((() => notFoundPost) as any),
            l.typedRef<BlockedPost>((() => blockedPost) as any),
          ],
          false,
        ),
      ),
    ),
    threadContext: l.optional(
      l.ref<ThreadContext>((() => threadContext) as any),
    ),
  }),
)

export { threadViewPost }

type NotFoundPost = {
  $type?: 'app.bsky.feed.defs#notFoundPost'
  uri: l.AtUriString
  notFound: true
}

export type { NotFoundPost }

const notFoundPost = l.typedObject<NotFoundPost>(
  $nsid,
  'notFoundPost',
  l.object({ uri: l.string({ format: 'at-uri' }), notFound: l.literal(true) }),
)

export { notFoundPost }

type BlockedPost = {
  $type?: 'app.bsky.feed.defs#blockedPost'
  uri: l.AtUriString
  blocked: true
  author: BlockedAuthor
}

export type { BlockedPost }

const blockedPost = l.typedObject<BlockedPost>(
  $nsid,
  'blockedPost',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    blocked: l.literal(true),
    author: l.ref<BlockedAuthor>((() => blockedAuthor) as any),
  }),
)

export { blockedPost }

type BlockedAuthor = {
  $type?: 'app.bsky.feed.defs#blockedAuthor'
  did: l.DidString
  viewer?: ActorDefs.ViewerState
}

export type { BlockedAuthor }

const blockedAuthor = l.typedObject<BlockedAuthor>(
  $nsid,
  'blockedAuthor',
  l.object({
    did: l.string({ format: 'did' }),
    viewer: l.optional(
      l.ref<ActorDefs.ViewerState>((() => ActorDefs.viewerState) as any),
    ),
  }),
)

export { blockedAuthor }

type GeneratorView = {
  $type?: 'app.bsky.feed.defs#generatorView'
  uri: l.AtUriString
  cid: l.CidString
  did: l.DidString
  creator: ActorDefs.ProfileView
  displayName: string
  description?: string
  descriptionFacets?: RichtextFacet.Main[]
  avatar?: l.UriString
  likeCount?: number
  acceptsInteractions?: boolean
  labels?: LabelDefs.Label[]
  viewer?: GeneratorViewerState
  contentMode?:
    | 'app.bsky.feed.defs#contentModeUnspecified'
    | 'app.bsky.feed.defs#contentModeVideo'
    | l.UnknownString
  indexedAt: l.DatetimeString
}

export type { GeneratorView }

const generatorView = l.typedObject<GeneratorView>(
  $nsid,
  'generatorView',
  l.object({
    uri: l.string({ format: 'at-uri' }),
    cid: l.string({ format: 'cid' }),
    did: l.string({ format: 'did' }),
    creator: l.ref<ActorDefs.ProfileView>((() => ActorDefs.profileView) as any),
    displayName: l.string(),
    description: l.optional(l.string({ maxGraphemes: 300, maxLength: 3000 })),
    descriptionFacets: l.optional(
      l.array(l.ref<RichtextFacet.Main>((() => RichtextFacet.main) as any)),
    ),
    avatar: l.optional(l.string({ format: 'uri' })),
    likeCount: l.optional(l.integer({ minimum: 0 })),
    acceptsInteractions: l.optional(l.boolean()),
    labels: l.optional(
      l.array(l.ref<LabelDefs.Label>((() => LabelDefs.label) as any)),
    ),
    viewer: l.optional(
      l.ref<GeneratorViewerState>((() => generatorViewerState) as any),
    ),
    contentMode: l.optional(
      l.string<{
        knownValues: [
          'app.bsky.feed.defs#contentModeUnspecified',
          'app.bsky.feed.defs#contentModeVideo',
        ]
      }>(),
    ),
    indexedAt: l.string({ format: 'datetime' }),
  }),
)

export { generatorView }

type GeneratorViewerState = {
  $type?: 'app.bsky.feed.defs#generatorViewerState'
  like?: l.AtUriString
}

export type { GeneratorViewerState }

const generatorViewerState = l.typedObject<GeneratorViewerState>(
  $nsid,
  'generatorViewerState',
  l.object({ like: l.optional(l.string({ format: 'at-uri' })) }),
)

export { generatorViewerState }

type SkeletonFeedPost = {
  $type?: 'app.bsky.feed.defs#skeletonFeedPost'
  post: l.AtUriString
  reason?:
    | l.$Typed<SkeletonReasonRepost>
    | l.$Typed<SkeletonReasonPin>
    | l.Unknown$TypedObject

  /**
   * Context that will be passed through to client and may be passed to feed generator back alongside interactions.
   */
  feedContext?: string
}

export type { SkeletonFeedPost }

const skeletonFeedPost = l.typedObject<SkeletonFeedPost>(
  $nsid,
  'skeletonFeedPost',
  l.object({
    post: l.string({ format: 'at-uri' }),
    reason: l.optional(
      l.typedUnion(
        [
          l.typedRef<SkeletonReasonRepost>((() => skeletonReasonRepost) as any),
          l.typedRef<SkeletonReasonPin>((() => skeletonReasonPin) as any),
        ],
        false,
      ),
    ),
    feedContext: l.optional(l.string({ maxLength: 2000 })),
  }),
)

export { skeletonFeedPost }

type SkeletonReasonRepost = {
  $type?: 'app.bsky.feed.defs#skeletonReasonRepost'
  repost: l.AtUriString
}

export type { SkeletonReasonRepost }

const skeletonReasonRepost = l.typedObject<SkeletonReasonRepost>(
  $nsid,
  'skeletonReasonRepost',
  l.object({ repost: l.string({ format: 'at-uri' }) }),
)

export { skeletonReasonRepost }

type SkeletonReasonPin = { $type?: 'app.bsky.feed.defs#skeletonReasonPin' }

export type { SkeletonReasonPin }

const skeletonReasonPin = l.typedObject<SkeletonReasonPin>(
  $nsid,
  'skeletonReasonPin',
  l.object({}),
)

export { skeletonReasonPin }

type ThreadgateView = {
  $type?: 'app.bsky.feed.defs#threadgateView'
  uri?: l.AtUriString
  cid?: l.CidString
  record?: l.LexMap
  lists?: GraphDefs.ListViewBasic[]
}

export type { ThreadgateView }

const threadgateView = l.typedObject<ThreadgateView>(
  $nsid,
  'threadgateView',
  l.object({
    uri: l.optional(l.string({ format: 'at-uri' })),
    cid: l.optional(l.string({ format: 'cid' })),
    record: l.optional(l.lexMap()),
    lists: l.optional(
      l.array(
        l.ref<GraphDefs.ListViewBasic>((() => GraphDefs.listViewBasic) as any),
      ),
    ),
  }),
)

export { threadgateView }

type Interaction = {
  $type?: 'app.bsky.feed.defs#interaction'
  item?: l.AtUriString
  event?:
    | 'app.bsky.feed.defs#requestLess'
    | 'app.bsky.feed.defs#requestMore'
    | 'app.bsky.feed.defs#clickthroughItem'
    | 'app.bsky.feed.defs#clickthroughAuthor'
    | 'app.bsky.feed.defs#clickthroughReposter'
    | 'app.bsky.feed.defs#clickthroughEmbed'
    | 'app.bsky.feed.defs#interactionSeen'
    | 'app.bsky.feed.defs#interactionLike'
    | 'app.bsky.feed.defs#interactionRepost'
    | 'app.bsky.feed.defs#interactionReply'
    | 'app.bsky.feed.defs#interactionQuote'
    | 'app.bsky.feed.defs#interactionShare'
    | l.UnknownString

  /**
   * Context on a feed item that was originally supplied by the feed generator on getFeedSkeleton.
   */
  feedContext?: string

  /**
   * Unique identifier per request that may be passed back alongside interactions.
   */
  reqId?: string
}

export type { Interaction }

const interaction = l.typedObject<Interaction>(
  $nsid,
  'interaction',
  l.object({
    item: l.optional(l.string({ format: 'at-uri' })),
    event: l.optional(
      l.string<{
        knownValues: [
          'app.bsky.feed.defs#requestLess',
          'app.bsky.feed.defs#requestMore',
          'app.bsky.feed.defs#clickthroughItem',
          'app.bsky.feed.defs#clickthroughAuthor',
          'app.bsky.feed.defs#clickthroughReposter',
          'app.bsky.feed.defs#clickthroughEmbed',
          'app.bsky.feed.defs#interactionSeen',
          'app.bsky.feed.defs#interactionLike',
          'app.bsky.feed.defs#interactionRepost',
          'app.bsky.feed.defs#interactionReply',
          'app.bsky.feed.defs#interactionQuote',
          'app.bsky.feed.defs#interactionShare',
        ]
      }>(),
    ),
    feedContext: l.optional(l.string({ maxLength: 2000 })),
    reqId: l.optional(l.string({ maxLength: 100 })),
  }),
)

export { interaction }

/** Request that less content like the given feed item be shown in the feed */
type RequestLess = 'app.bsky.feed.defs#requestLess'

export type { RequestLess }

/** Request that less content like the given feed item be shown in the feed */
const requestLess = l.token($nsid, 'requestLess')

export { requestLess }

/** Request that more content like the given feed item be shown in the feed */
type RequestMore = 'app.bsky.feed.defs#requestMore'

export type { RequestMore }

/** Request that more content like the given feed item be shown in the feed */
const requestMore = l.token($nsid, 'requestMore')

export { requestMore }

/** User clicked through to the feed item */
type ClickthroughItem = 'app.bsky.feed.defs#clickthroughItem'

export type { ClickthroughItem }

/** User clicked through to the feed item */
const clickthroughItem = l.token($nsid, 'clickthroughItem')

export { clickthroughItem }

/** User clicked through to the author of the feed item */
type ClickthroughAuthor = 'app.bsky.feed.defs#clickthroughAuthor'

export type { ClickthroughAuthor }

/** User clicked through to the author of the feed item */
const clickthroughAuthor = l.token($nsid, 'clickthroughAuthor')

export { clickthroughAuthor }

/** User clicked through to the reposter of the feed item */
type ClickthroughReposter = 'app.bsky.feed.defs#clickthroughReposter'

export type { ClickthroughReposter }

/** User clicked through to the reposter of the feed item */
const clickthroughReposter = l.token($nsid, 'clickthroughReposter')

export { clickthroughReposter }

/** User clicked through to the embedded content of the feed item */
type ClickthroughEmbed = 'app.bsky.feed.defs#clickthroughEmbed'

export type { ClickthroughEmbed }

/** User clicked through to the embedded content of the feed item */
const clickthroughEmbed = l.token($nsid, 'clickthroughEmbed')

export { clickthroughEmbed }

/** Declares the feed generator returns any types of posts. */
type ContentModeUnspecified = 'app.bsky.feed.defs#contentModeUnspecified'

export type { ContentModeUnspecified }

/** Declares the feed generator returns any types of posts. */
const contentModeUnspecified = l.token($nsid, 'contentModeUnspecified')

export { contentModeUnspecified }

/** Declares the feed generator returns posts containing app.bsky.embed.video embeds. */
type ContentModeVideo = 'app.bsky.feed.defs#contentModeVideo'

export type { ContentModeVideo }

/** Declares the feed generator returns posts containing app.bsky.embed.video embeds. */
const contentModeVideo = l.token($nsid, 'contentModeVideo')

export { contentModeVideo }

/** Feed item was seen by user */
type InteractionSeen = 'app.bsky.feed.defs#interactionSeen'

export type { InteractionSeen }

/** Feed item was seen by user */
const interactionSeen = l.token($nsid, 'interactionSeen')

export { interactionSeen }

/** User liked the feed item */
type InteractionLike = 'app.bsky.feed.defs#interactionLike'

export type { InteractionLike }

/** User liked the feed item */
const interactionLike = l.token($nsid, 'interactionLike')

export { interactionLike }

/** User reposted the feed item */
type InteractionRepost = 'app.bsky.feed.defs#interactionRepost'

export type { InteractionRepost }

/** User reposted the feed item */
const interactionRepost = l.token($nsid, 'interactionRepost')

export { interactionRepost }

/** User replied to the feed item */
type InteractionReply = 'app.bsky.feed.defs#interactionReply'

export type { InteractionReply }

/** User replied to the feed item */
const interactionReply = l.token($nsid, 'interactionReply')

export { interactionReply }

/** User quoted the feed item */
type InteractionQuote = 'app.bsky.feed.defs#interactionQuote'

export type { InteractionQuote }

/** User quoted the feed item */
const interactionQuote = l.token($nsid, 'interactionQuote')

export { interactionQuote }

/** User shared the feed item */
type InteractionShare = 'app.bsky.feed.defs#interactionShare'

export type { InteractionShare }

/** User shared the feed item */
const interactionShare = l.token($nsid, 'interactionShare')

export { interactionShare }
